const CHART_NAVIGATOR_ICON_URL =
  'https://engage.apptopia.com/hubfs/App_Icons/slider-btn/slider-btn-v2@2x.png';

export default ({ xAxis, ...restOptions } = {}) => ({
  navigator: {
    adaptToUpdatedData: true,
    height: 16,
    margin: 38,
    maskFill: '#F8F9FB',
    outlineWidth: 0,
    strokeWidth: 0,
    series: {
      animation: false,
      lineWidth: 1,
      fillOpacity: 0,
      type: 'line',
      color: 'transparent',
    },
    xAxis: {
      labels: { enabled: false },
      gridLineWidth: 0,
      ...(xAxis || {}),
    },
    yAxis: {
      min: 0,
      max: 1,
      endOnTick: true,
      startOnTick: true,
      tickPixelInterval: 16,
      plotBands: [
        {
          color: '#F2F4F7',
          from: 0,
          to: 1,
          zIndex: 3,
          className: 'plot-band-mask',
        },
      ],
    },
    handles: {
      backgroundColor: '',
      borderColor: '',
      height: 16,
      width: 48,
      symbols: [`url(${CHART_NAVIGATOR_ICON_URL})`, `url(${CHART_NAVIGATOR_ICON_URL})`],
      customPlacement: [
        { x: 0, y: 1 },
        { x: -48, y: 1 },
      ],
    },
    ...(restOptions || {}),
  },
});
